/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';

type PropsType = {
  viewTab: string
};

const tabs = [
  {
    link: 'account',
    label: 'account'
  },
  {
    link: 'referrals',
    label: 'referrals'
  }
];

const SettingsNavigation = ({ viewTab }: PropsType): React.Element<typeof React.Fragment> => {
  return (
    <div className="navbar navbar-default navbar-submenu">
      <ul className="nav navbar-nav navbar-right">
        {_.map(tabs, (tabI: {}, tabK: number): React.Element<'li'> => (
          <li
            key={`SettingsPage-${tabK}`}
            className={viewTab === tabI.link ? 'active' : ''}
          >
            <Link to={`/settings/${tabI.link}`}>{tabI.label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SettingsNavigation;
